import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import administrativeDecisionFeedbackFormStyle from "./AdministrativeDecisionFeedbackFormStyle";
import Recommendation from "./Modules/Recommendation";
import ObjectionConsequences from "./Modules/ObjectionConsequences";
import AdministrativeDecisionStatusClient from "./Modules/AdministrativeDecisionStatusClient";
import AdministrativeDecisionFeedbackClient from "./Modules/AdministrativeDecisionFeedbackClient";
import { useForm } from "@/src/provider/Form/FormProvider";
import AdditionalFeedbackMessage from "./Modules/AdditionalFeedbackMessage";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";

type AdministrativeDecisionFeedbackFormProps = {
  product: AbstractCase;
  isLoading: boolean;
};

const AdministrativeDecisionFeedbackForm = ({ product, isLoading }: AdministrativeDecisionFeedbackFormProps) => {
  const { handleSubmit, values } = useForm();

  return (
    <Paper sx={administrativeDecisionFeedbackFormStyle.paper} elevation={4}>
      <Box
        component={"form"}
        sx={{ ...administrativeDecisionFeedbackFormStyle.applicationForm, ...administrativeDecisionFeedbackFormStyle.wizardForm }}
        onSubmit={handleSubmit}
      >
        <Grid
          container
          sx={{
            justifyContent: "flex-start",
            alignItems: "baseline"
          }}>
          <AdministrativeDecisionStatusClient />
          <Recommendation product={product} />
          <AdministrativeDecisionFeedbackClient product={product} />
          <ObjectionConsequences product={product} />
          <AdditionalFeedbackMessage />
        </Grid>
        <ButtonLoading sx={administrativeDecisionFeedbackFormStyle.button} fullWidth variant="contained" color="primary" type="submit" isLoading={isLoading}>
          Meine Rückmeldung übermitteln
        </ButtonLoading>
      </Box>
    </Paper>
  );
};
export default AdministrativeDecisionFeedbackForm;
